<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="projectId" slot-scope="scope">
        <div>{{ getProjectName(scope.row.projectId) }}</div>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="viewHandler(scope.row)"
          >查看</el-button
        >
        <el-button
          type="text"
          size="small"
          v-if="permission.order_designate"
          icon="el-icon-thumb"
          @click="appointHandler(scope.row)"
          >派单</el-button
        >
        <el-button
          type="text"
          size="small"
          v-if="permission.order_rob"
          icon="el-icon-phone-outline"
          @click="orderGrabbingHandler(scope.row)"
          >抢单</el-button
        >
        <el-button
          type="text"
          size="small"
          v-if="permission.order_cancel"
          icon="el-icon-circle-close"
          @click="cancelHandler(scope.row)"
          >取消</el-button
        >
        <!-- <el-button type="text" size="small" icon="el-icon-edit" @click="editHandler(scope.row)">编辑</el-button> -->
      </template>
      <template slot="menuLeft">
        <!-- <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.order_delete"
                   @click="handleDelete">删 除
        </el-button> -->
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addOrderHandler"
          v-if="permission.order_add"
        >
          新增
        </el-button>
      </template>

      <template slot="projectIdSearch">
        <el-select v-model="form.projectId" @change="changeHandler">
          <el-option
            v-for="(item, index) in projectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>

          <!-- :value="form.areaId" -->
      <template slot="areaIdSearch">
        <el-select
          v-model="form.areaId"
          placeholder="请选择存放区域"
          clearable
          style="width: 100%"
          ref="connectSelect"
          name="connectSelect"
          @clear="clearSelectHandler"
        >
          <el-option
            :value="form.areaId"
            show-all-levels
            :label="form.areaName"
          >
            <el-tree
              node-key="id"
              :data="treeFormAreaData"
              :props="treeProps"
              :load="editAreaLazyLoadTree"
              lazy
              @node-click="editAreaNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
    </avue-crud>

    <el-dialog
      title="查看"
      :visible.sync="dialogOrderViewBoxVisible"
      append-to-body
    >
      <el-form inline label-width="100px">
        <el-form-item label="项目名称">
          <el-select disabled v-model="viewForm.projectId">
            <el-option
              v-for="(item, index) in projectList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求人">
          <el-input disabled v-model="viewForm.requireManName"></el-input>
        </el-form-item>
        <el-form-item label="需求部门">
          <el-input disabled v-model="viewForm.requireDeptName"></el-input>
        </el-form-item>
        <el-form-item label="服务地点">
          <el-input disabled v-model="viewForm.areaName"></el-input>
        </el-form-item>
        <el-form-item label="期望到场">
          <el-input disabled v-model="viewForm.expectStartTime"></el-input>
        </el-form-item>
        <el-form-item label="需求来源">
          <el-input disabled v-model="viewForm.sourceName"></el-input>
        </el-form-item>
        <el-form-item label="需求描述">
          <el-input disabled v-model="viewForm.description"></el-input>
        </el-form-item>
        <el-form-item label="需求附件">
          <el-upload
            disabled
            action="/api/v4ward/oss/customEndpoint/put-file"
            list-type="text"
            :file-list="viewForm.attaches"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <el-button disabled size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="派单"
      :visible.sync="dialogOrderAppointBoxVisible"
      append-to-body
    >
      <el-form label-width="100px" v-if="dialogOrderAppointBoxVisible">
        <!-- <el-form-item label="服务班组"> -->
          <!-- <el-select disabled v-model="appointForm.groupId">
              <el-option
                v-for="(item,index) in groupList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select> -->
          <!-- <el-input disabled v-model="appointForm.groupName"></el-input>
          <el-input
            v-model="appointForm.groupId"
            style="display: none"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="转派人员" required>
          <el-select style="width:100%" v-model="appointForm.handerId">
              <!-- v-for="(item, index) in userPrincipalList" -->
            <el-option
            v-for="(item, index) in userMemberList"
              :key="index"
              :label="item.realName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="协同人员" required>
          <el-select v-model="appointForm.cooperateList_" multiple>
            <el-option
              v-for="(item, index) in userMemberList"
              :key="index"
              :label="item.realName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="备注" required>
          <el-input type="textarea" v-model="appointForm.remark"></el-input>
                        <remarkModel :remark.sync="appointForm.remark" ref="appointFormRemarkModel"></remarkModel>
        </el-form-item>



        <el-form-item label="" required>

          <!-- <el-tag type="warning">标签四</el-tag> -->
          <!-- <el-select v-model="remarkAppointTemplate" multiple @change="handlerAppointRemarkChange">
            <el-option
              v-for="(item, index) in remarkAppointList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select> -->
          <!-- <el-select>
            <el-option></el-option>
          </el-select> -->
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitAppointForm">
            保存
          </el-button>
          <el-button @click="dialogOrderAppointBoxVisible = false">
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="抢单"
      :visible.sync="dialogOrderGrabbingBoxVisible"
      append-to-body
    >
      <el-form label-width="100px" v-if="dialogOrderGrabbingBoxVisible">
        <!-- <el-form-item label="服务班组">
          <el-input disabled v-model="orderGrabbingForm.groupName"></el-input>
          <el-input
            v-model="orderGrabbingForm.groupId"
            style="display: none"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="协同人员" required>
          <el-select v-model="orderGrabbingForm.cooperateList_" multiple>
            <el-option
              v-for="(item, index) in userMemberList"
              :key="index"
              :label="item.realName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="备注" required>
          <el-input
            type="textarea"
            v-model="orderGrabbingForm.remark"
          ></el-input>
          <remarkModel :remark.sync="orderGrabbingForm.remark" ref="orderGrabbingFormRemarkModel"></remarkModel>
        </el-form-item>


        <el-form-item label="" required>


          <!-- <el-select v-model="remarkGrabbingTemplate" multiple @change="handlerGrabbingRemarkChange">
            <el-option
              v-for="(item, index) in remarkGrabbingList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select> -->
          <!-- <el-select>
            <el-option></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitOrderGrabbingForm">
            保存
          </el-button>
          <el-button @click="dialogOrderGrabbingBoxVisible = false">
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="取消工单"
      :visible.sync="dialogOrderCancelBoxVisible"
      append-to-body
    >
      <el-form label-width="100px" v-if="dialogOrderCancelBoxVisible">
        <el-form-item label="备注" required>
          <el-input type="textarea" v-model="orderCancelForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="附件">

          <el-upload
            class="avatar-uploader"
            action="/api/v4ward/oss/customEndpoint/put-file"
            :show-file-list="orderCancelForm.fileList"
            :on-success="imgUploadSuccess"
            :on-remove="imgHandleRemove"
            :before-upload="beforeAvatarUpload"
          >
            <!-- accept="image/*" -->
            <!-- <img v-if="orderCancelForm.imgUrl" :src="orderCancelForm.imgUrl" class="avatar"> -->
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
            <el-button>上传附件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传不超过5M的文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitOrderCancelForm">
            保存
          </el-button>
          <el-button @click="dialogOrderCancelBoxVisible = false">
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--  -->
    <el-dialog
      title="新增工单"
      width="70%"
      :visible.sync="dialogOrderCreateBoxVisible"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- 通用表单项PYC -->
      <el-form
        v-if="dialogOrderCreateBoxVisible"
        label-width="120px"
        ref="addForm"
        :rules="addFormRules"
        :model="addForm"
      >
        <el-form-item label="来源" prop="source">
          <el-select v-model="addForm.source">
            <el-option
              v-for="(item, index) in orderRequireSourceList"
              :key="index"
              :label="item.dictValue"
              :value="item.dictKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目" prop="projectId">
          <el-select v-model="addForm.projectId" @change="changeHandler_">
            <el-option
              v-for="(item, index) in projectList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务类型" prop="moduleType">
          <el-select
            v-model="addForm.moduleType"
            @change="orderModuleTpyeChange"
          >
            <el-option
              v-for="(item, index) in moduleTypeList"
              :key="index"
              :label="item.dictValue"
              :value="item.dictKey"
            ></el-option>
          </el-select>
        </el-form-item>
<!-- subModuleList -->

        <el-form-item label="子类型名称" prop="subModuleId">
          <el-select
            v-model="addForm.subModuleId"
            @change="orderSubModuleIdChange"
          >
            <el-option
              v-for="(item, index) in subModuleList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="服务地点" prop="areaId">
          <el-select
            v-model="addForm.areaId"
            :value="addForm.areaId"
            placeholder="请选择服务地点"
            clearable
            ref="addConnectSelect"
            @change="areaIdChange"
          >
            <el-option
              :value="addForm.areaId"
              show-all-levels
              :label="addForm.areaName"
            >
              <el-tree
                node-key="id"
                :data="treeFormAreaData"
                :props="treeProps"
                :load="editAreaLazyLoadTree"
                lazy
                @node-click="editAreaNodeTreeClick_"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求部门" prop="requireDeptName">
          <el-input v-model="addForm.requireDeptName" style="width:12.4rem;" readonly></el-input>
        </el-form-item>
        <el-form-item label="需求人" prop="requireMainId">
          <el-select
            v-model="addForm.requireMainId"
            @change="changeRequireUserHandler_"
          >
            <el-option
              v-for="(item, index) in requireUserList"
              :key="index"
              :label="item.realName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input
            v-model="addForm.requireManName"
            style="display: none"
          ></el-input>
        </el-form-item>
        <el-form-item label="紧急程度" prop="urgentLevel">
          <el-select v-model="addForm.urgentLevel">
            <el-option
              v-for="(item, index) in urgentLevelList"
              :key="index"
              :label="item.dictValue"
              :value="item.dictKey"
            ></el-option>
          </el-select>
          <el-input
            v-model="addForm.requireManName"
            style="display: none"
          ></el-input>
        </el-form-item>
        <!-- 设备巡检不需要期望到场时间 -->
        <el-form-item
          v-if="choosenModuleName !== 'EquipmentInspection'"
          prop="expectStartTime"
          label="期望到场时间"
        >
          <el-date-picker
            v-model="addForm.expectStartTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="工单描述" prop="description">
          <el-input type="textarea" v-model="addForm.description"> </el-input>
        </el-form-item>
        <el-form-item
          v-if="positionFlag"
          label="需求位置纬度"
          prop="positionLatitude"
        >
          <el-input v-model="addForm.positionLatitude"></el-input>
        </el-form-item>
        <el-form-item
          v-if="positionFlag"
          label="需求位置经度"
          prop="positionLongitude"
        >
          <el-input v-model="addForm.positionLongitude"></el-input>
        </el-form-item>
        <el-form-item label="附件上传">
          <VUpload :fileList.sync="fileList" />
        </el-form-item>
      </el-form>
      <!-- 特有表单项start -->
      <component
        ref="addFormExtend"
        :is="choosenModuleName"
        :projectId="addForm.projectId"
        :addFormExtend="addFormExtend"
      ></component>
      <!-- 特有表单项end -->
      <div slot="footer">
        <el-button type="primary" @click="submitOrderCreateForm">
          保存
        </el-button>
        <el-button @click="dialogOrderCreateBoxVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  getList_,
  remove,
  update,
  getGroupById,
  getGroupName,
  appointOrder,
  grabOrder,
  cancelOrder,
  getOrderUrgentLevel,
  getModuleType,
  createOrder,
  getOrderDetail,getDictData,
  getDeptDetailByAreaId,
  getDeptUserListByDeptId,
  getSubModuleList
} from "@/api/crmedical/order/order";
import {
  modulesSetting,
  settingPositionflag,
  getDictionary,
} from "@/api/crmedical/order/order-add";
import { getRemarkList } from '@/api/crmedical/order/order-list/order-list';
import { mapGetters } from "vuex";

import { vString, vLongitude, vLatitude } from "@/util/validate";

import { lazyTree } from "@/api/crmedical/project/area";
import {
  getMenberUserList,
  getProjectList,
  getPrincipalUserList,
  getUserListByDepartmentId,
} from "@/api/crmedical/group/group";
// 工单新增模块
import modules from "./order-add/modules";
import modulesConfig from "./order-add/modulesConfig";
// 上传
import VUpload from "@/views/components/v-upload";
    import remarkModel from "./order-list/remark-model";

export default {
  components: { ...modules,VUpload, remarkModel},
  data() {
    return {
      subModuleList:[],
      remarkAppointTemplate:'',
      remarkGrabbingTemplate:'',
      remarkAppointList:[],remarkGrabbingList:[],
      // projectList:[],
      urgentLevelList: [],
      moduleTypeList: [],
      orderRequireSourceList: [],
      // 新增表单 所选择的类型id
      choosenTypeId: "",
      choosenModuleName: "",
      // 是否需要经纬度
      positionFlag: false,
      // 新增工单form通用数据
      addForm: {},
      // 上传
      fileList:[],
      addFormRules: {
        source: [{ required: true, message: "请选择来源", trigger: "change" }],
        projectId: [
          { required: true, message: "请选择项目", trigger: "change" },
        ],
        moduleType: [
          { required: true, message: "请选择服务类型", trigger: "change" }
        ],
        areaId: [
          { required: true, message: "请选择服务地点", trigger: "change" },
        ],
        requireMainId: [
          { required: true, message: "请选择需求人", trigger: "change" },
        ],
        urgentLevel: [
          { required: true, message: "请选择紧急程度", trigger: "blur" },
        ],
        expectStartTime: [
          { required: true, message: "请选择期望到场时间", trigger: "change" },
        ],
        description: [
          { required: true, message: "请输入工单描述", trigger: "change" },
          { validator: vString("工单描述"), trigger: "change" },
        ],
        positionLatitude: [
          { required: true, message: "请输入纬度", trigger: "change" },
          { validator: vLatitude(), trigger: "change" },
        ],
        positionLongitude: [
          { required: true, message: "请输入经度", trigger: "change" },
          { validator: vLongitude(), trigger: "change" },
        ],
      },
      addFormExtend: {},
      requireUserList: [],
      dialogOrderCreateBoxVisible: false,
      treeProps: {
        //标题
        label: "name",
        //值
        value: "id",
        //子节点
        children: "zones",
        //是否叶子节点
        isLeaf: "hasChildren",
        //本节点类型key值
        objectType: "id",
        //本节点类型名
        objectTypeName: "name",
      },
      treeFormAreaData: [],
      groupList: [],
      userList: [],
      appointForm: {
        userName_: [],
      },
      orderCancelForm: {
        fileList:[],
      },
      orderGrabbingForm: {},
      viewForm: {},
      editForm: {},
      projectList: [],
      dialogOrderCancelBoxVisible: false,
      dialogOrderAppointBoxVisible: false,
      dialogOrderGrabbingBoxVisible: false,
      dialogOrderViewBoxVisible: false,
      dialogOrderEditBoxVisible: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: "auto",
        // calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        addBtn: false,
        columnBtn: false,
        column: [
          {
            label: "工单编号",
            prop: "code",
          },
          {
            label: "项目名称",
            prop: "projectId",
            search: true,
            searchslot: true,
            slot: true,
          },
          {
            label: "工单类型",
            prop: "moduleType",
            display: false,
            type: "select",
            dicUrl: "/api/blade-system/dict/dictionary?code=module_type",
            dataType: "number",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            search: true,
          },

          {
            label: "需求人",
            prop: "requireManName",
            search: true,
          },
          {
            label: "紧急程度",
            prop: "urgentLevel",
            display: false,
            type: "select",
            dicUrl: "/api/blade-system/dict/dictionary?code=order_urgent_level",
            dataType: "number",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },

          {
            label: "服务地点",
            prop: "areaName",
          },
          {
            label: "服务地点",
            prop: "areaId",
            hide: true,
            search: true,
            searchslot: true,
          },
          {
            label: "期望到场时间",
            prop: "expectStartTime",
          },
          {
            label: "描述",
            prop: "description",
          },
        ],
      },
      data: [],
    };
  },
  created() {
    // 获取项目列表
    getProjectList().then((res) => {
      console.log(res);
      this.projectList = res.data;
      this.query = {projectId: this.projectList[0].id}
      this.form.projectId = this.projectList[0].id;

      lazyTree({ parentId: 0, projectId: this.form.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormAreaData = data;
        setTimeout(()=>{
          this.form = Object.assign({}, this.form, {
            areaName: '',
            areaId: '',
          });
        })
      });

      if(this.$route.query.id){
        setTimeout(()=>{

          this.onLoad_();
        });
      }else{
        setTimeout(()=>{

          this.onLoad();
        });
      }
    });

  },
  activated(){

      if(this.$route.query.id){
        setTimeout(()=>{

          this.onLoad_();
        });
      }else{

        setTimeout(()=>{

          this.onLoad();
        });
      }
  },
  computed: {
    ...mapGetters(["permission"]),
    ...mapGetters(["userInfo"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.order_add, false),
        viewBtn: this.vaildData(this.permission.order_view, false),
        delBtn: this.vaildData(this.permission.order_delete, false),
        editBtn: this.vaildData(this.permission.order_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    areaIdChange(val){

      console.log(val);
    },
    handlerAppointRemarkChange(val){
      this.appointForm.remark = val.join(' ');
      console.log(val);
    },
    handlerGrabbingRemarkChange(val){
      this.orderGrabbingForm.remark= val.join(' ');
      console.log(val);
    },
        clearSelectHandler(){

          console.log('66666');
          setTimeout(()=>{
            document.querySelector('input[name=connectSelect]').value = '';
            Object.assign({},this.form,{areaName:'',areaId:''});
          })
        },
    // 服务类型切換
    orderModuleTpyeChange(val) {
      console.log('this.addForm.moduleTye:=>',this.addForm.moduleType);

      getSubModuleList({
        moduleType: this.addForm.moduleType,
        projectId: this.addForm.projectId
      }).then((res)=>{
        this.subModuleList = res.data;
        console.log(res);
      });
      // 动态组件 val:1 ===> this.choosenModuleName:'Clean'
      this.choosenModuleName = modulesConfig[val];
      this.addFormExtend = {};
      // 查询是否需要经纬度
      settingPositionflag({
        projectId: this.addForm.projectId,
        moduleType: this.addForm.moduleType,
      }).then((res) => {
        this.positionFlag = res.data;
      });
    },
    getProjectName(id) {
      let projectName = "";
      this.projectList.forEach((ele, index) => {
        if (id === ele.id) {
          projectName = ele.name;
        }
      });
      return projectName;
    },
    changeRequireUserHandler_(val) {
      let tempRequiredUserName = "";
      this.requireUserList.forEach((ele, index) => {
        if (val === ele.id) {
          tempRequiredUserName = ele.realName;
        }
      });
      this.addForm = Object.assign({}, this.addForm, {
        requireManName: tempRequiredUserName,
      });
    },
    addOrderHandler() {
      this.addForm = {};
      this.fileList = [];
      this.addFormExtend = {};
      this.choosenTypeId = "";
      this.choosenModuleName = "";
      // 需求来源
      getDictionary({ code: "order_require_source" }).then((res) => {
        this.orderRequireSourceList = res.data;
      });
      getOrderUrgentLevel().then((res) => {
        console.log(res);
        this.urgentLevelList = res.data;
      });
      getUserListByDepartmentId({}).then((res) => {
        console.log(res);
        this.requireUserList = res.data;
        setTimeout(()=>{

          this.addForm.requireMainId = this.userInfo.user_id;
          this.addForm = Object.assign({},this.addForm,{requireMainId:this.userInfo.user_id})
        })
        console.log(this.userInfo.user_id);
      });
      this.dialogOrderCreateBoxVisible = true;
    },
    editAreaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyTree({ parentId: id, projectId: this.editForm.projectId }).then(
        ({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          resolve(data);
        }
      );
    },
    editAreaNodeTreeClick(node) {
      setTimeout(() => {
        let nodeId = node.id;
        let nodeTitle = node.name;
        this.form = Object.assign({}, this.form, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.connectSelect.blur();
        this.areaNameFlag = true;
        this.areaIdFlag = false;
      }, 0);
    },
    changeHandler(value) {
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormAreaData = data;
        setTimeout(()=>{
          this.form = Object.assign({}, this.form, {
            areaName: '',
            areaId: '',
          });
        })
      });
    },
    editAreaNodeTreeClick_(node) {
      setTimeout(() => {
        console.log(node);
        let nodeId = node.id;
        let nodeTitle = node.name;
        this.addForm.requireMainId = '';
        this.addForm = Object.assign({}, this.addForm, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.addConnectSelect.blur();
        this.areaNameFlag = true;
        this.areaIdFlag = false;
        getDeptDetailByAreaId({areaId:nodeId}).then((res)=>{
          console.log(res);
          // this.addForm.requireDeptName = res.data.deptName;
          // setTimeout(()=>{
          this.addForm = Object.assign({},this.addForm,{requireDeptName:res.data.deptName})
          getDeptUserListByDeptId({deptId:res.data.id}).then((res)=>{
            console.log(res);
            this.requireUserList = res.data;
          })
          //   console.log(this.addForm);
          // })
        });
      }, 0);
    },
    // 切换 项目
    changeHandler_(value) {
      // 清空服务类型
      // 清空区域 区域暂时未和项目挂钩,下面不再拉取区域数据
      this.addForm = Object.assign({},this.addForm,{areaId:'',areaName:'',moduleType:''})
      this.moduleTypeList = [];
      // 是否需要经纬度
      this.positionFlag = false;
      // 动态获取服务类型
      modulesSetting(value).then((res) => {
        if (res.success) {
          this.moduleTypeList = res.data;
        }
      });
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormAreaData = data;
      });
    },

    // 新增工单
    submitOrderCreateForm() {
      // 校验通用表
      this.$refs.addForm.validate((valiForm) => {
        if (!valiForm) {
          return false;
        }
        // 校验拓展表
        if (this.$refs.addFormExtend) {
          this.$refs.addFormExtend.validate().then((valiFormExtend) => {
            if (!(valiForm && valiFormExtend)) {
              return;
            } else {
              this.addForm.moduleJson = JSON.stringify(this.addFormExtend);
              this.addForm.attachList = this.fileList;
              createOrder(this.addForm).then((res) => {
                this.dialogOrderCreateBoxVisible = false;
                if (res.success == true) {
                  this.$message.success(res.msg);
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
          });
        } else {
          // 无拓展表的情况
          this.addForm.moduleJson = JSON.stringify({});
          createOrder(this.addForm).then((res) => {
            this.dialogOrderCreateBoxVisible = false;
            if (res.success == true) {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },

    submitAppointForm() {
      let itemList = [];
      this.appointForm.cooperateList = [];
      // console.log("this.appointForm.cooperateList_===>",this.appointForm.cooperateList_);
      // let cooperateUserList_ = this.deepClone(this.appointForm.cooperateList_);
      // let idList = cooperateUserList_.splice(",");
      // console.log("this.appointForm.cooperateList_===>",this.appointForm.cooperateList_);
      // this.userMemberList.forEach((ele, index) => {
      //   idList.forEach((e, i) => {
      //     if (e === ele.id) {
      //       itemList.push({
      //         userName: ele.realName,
      //         userId: ele.id,
      //       });
      //     }
      //   });
      // });
      this.appointForm.cooperateList = itemList;
      console.log(this.appointForm.cooperateList);
      // return
      if(!this.appointForm.handerId){
        this.$message.error('请选择"转派人员"!');
        return;
      }
      // if(this.appointForm.cooperateList.length==0){
      //   this.$message.error('请选择"协同人员"!');
      //   return;
      // }
      if(!this.appointForm.remark){
        this.$message.error('请填写"备注"!');
        return;
      }
      appointOrder(this.appointForm).then((res) => {
        console.log(res);
        this.dialogOrderAppointBoxVisible = false;
      });
      //派单
    },
    submitOrderGrabbingForm() {
      // this.orderGrabbingForm
      let itemList = [];
      this.orderGrabbingForm.cooperateList = [];
      this.orderGrabbingForm.cooperateList = this.userMemberList;
      // console.log("this.orderGrabbingForm.cooperateList_===>",this.orderGrabbingForm.cooperateList_);
      // let cooperateUserList_ = this.deepClone(this.orderGrabbingForm.cooperateList_);
      // let idList = cooperateUserList_.splice(",");
      // console.log("this.orderGrabbingForm.cooperateList_===>",this.orderGrabbingForm.cooperateList_);
      // this.userMemberList.forEach((ele, index) => {
      //   idList.forEach((e, i) => {
      //     if (e === ele.id) {
      //       itemList.push({
      //         userName: ele.realName,
      //         userId: ele.id,
      //       });
      //     }
      //   });
      // });
      // this.orderGrabbingForm.cooperateList = itemList;
      // console.log(this.orderGrabbingForm.cooperateList);
      // console.log(this.orderGrabbingForm);
      // return;

      // if(this.orderGrabbingForm.cooperateList.length==0){
      //   this.$message.error('请选择"协同人员"!');
      //   return;
      // }
      if(!this.orderGrabbingForm.remark){
        this.$message.error('请填写"备注"!');
        return;
      }
      grabOrder(this.orderGrabbingForm).then((res) => {
        console.log(res);
        this.dialogOrderGrabbingBoxVisible = false;
      });
      //抢单
    },

    orderGrabbingHandler(row) {

      this.remarkGrabbingTemplate = '';
      this.orderGrabbingForm = this.deepClone(row);
      this.orderGrabbingForm.orderId = row.id;
      getRemarkList({orderId:row.id, actionType:2}).then((res)=>{
        console.log(res);
        this.remarkGrabbingList = res.data;
      });

          this.dialogOrderGrabbingBoxVisible = true;
          // this.dialogOrderGrabbingBoxVisible = true;
          getGroupName({
            // projectId: row.projectId,
            // moduleType: row.moduleType,
            orderId:row.id,
          }).then((res) => {
            console.log(res);
            this.orderGrabbingForm.groupName = res.data.name;
            this.orderGrabbingForm.groupId = res.data.id;



              // console.log(response);
              this.userMemberList = res.data.userList;

              this.dialogOrderGrabbingBoxVisible = true;
              setTimeout(()=>{
                  console.log('this.$refs.orderGrabbingFormRemarkModel====>' ,this.$refs.orderGrabbingFormRemarkModel);
                  console.log('this.$refs.orderGrabbingFormRemarkModel====>' ,res.data);
                  this.$refs.orderGrabbingFormRemarkModel.setRemarkList(this.remarkGrabbingList);
                })
            // getMenberUserList({ groupId: res.data.id }).then((response) => {


            //   console.log(response);
            //   this.userMemberList = response.data;
            //   this.dialogOrderGrabbingBoxVisible = true;
            //   setTimeout(()=>{
            //       console.log('this.$refs.orderGrabbingFormRemarkModel====>' ,this.$refs.orderGrabbingFormRemarkModel);
            //       console.log('this.$refs.orderGrabbingFormRemarkModel====>' ,res.data);
            //       this.$refs.orderGrabbingFormRemarkModel.setRemarkList(this.remarkGrabbingList);
            //     })
            // });



          });
    },
    appointHandler(row) {

      this.remarkAppointTemplate = '';
      this.appointForm = this.deepClone(row);
      this.appointForm.orderId = row.id;


            // getRemarkList({orderId:this.orderId,actionType:index}).then(res=>{
            //     this.$refs.complaintFormRemarkModel.setRemarkList(res.data);
            // })


      getRemarkList({orderId:row.id, actionType:1}).then((res)=>{
        console.log(res);
        this.remarkAppointList = res.data;

      });
      getGroupName({
        orderId:row.id,
        // projectId: row.projectId,
        // moduleType: row.moduleType
      }).then((res) => {
        console.log(res);
        this.appointForm.groupName = res.data.realName;
        this.appointForm.groupId = res.data.id;

          this.userMemberList = res.data.userList;
        // getMenberUserList({ groupId: res.data.id }).then((response) => {
        //   console.log(response);
        //   this.userMemberList = response.data;

      // getUserListByDepartmentId({}).then((res) => {
      //   console.log(res);
      //   this.requireUserList = res.data;
      // });
          getUserListByDepartmentId({ groupId: res.data.id }).then((response_)=>{
            console.log(response_);
            this.userPrincipalList = response_.data;
            this.dialogOrderAppointBoxVisible = true;
            setTimeout(()=>{
              console.log('this.$refs.appointFormRemarkModel====>' ,this.$refs.appointFormRemarkModel);
              console.log('this.$refs.appointFormRemarkModel====>' ,res.data);
              this.$refs.appointFormRemarkModel.setRemarkList(this.remarkAppointList);
            })
          });
          // this.dialogOrderAppointBoxVisible = true;
        // });

      });
    },
    cancelHandler(row) {
      this.orderCancelForm = Object.assign({},this.orderCancelForm,{remark:'',fileList:[]});

      // this.orderCancelForm.fileList = [];
      this.orderCancelForm.orderId = row.id;
      this.dialogOrderCancelBoxVisible = true;
    },
    imgUploadSuccess(response, file, fileList) {
      this.orderCancelForm.attachList = [];
      console.log(fileList);
      fileList.forEach((e) => {
        this.orderCancelForm.attachList.push({ id: e.response.data.id });
      });
    },
    submitOrderCancelForm() {
      console.log(this.orderCancelForm);

      if(!this.orderCancelForm.remark){
        this.$message.error('请填写"备注"!');
        return;
      }
      // if(!this.orderCancelForm.attachList||this.orderCancelForm.attachList.length==0){
      //   this.$message.error('请上传"附件"!');
      //   return;
      // }
      cancelOrder(this.orderCancelForm).then((res) => {
        console.log(res);
        this.dialogOrderCancelBoxVisible = false;
      });
    },
    viewHandler(row) {
      this.viewForm = row;
      getProjectList().then((res) => {
        console.log(res);
        this.projectList = res.data;
        // this.addGroupForm.projectId = this.projectList[0].id;
        getOrderDetail({orderId:row.id}).then((response)=>{
          this.viewForm = response.data.orderDetails[0];
           this.viewForm.areaName = this.tool.getDictionaryValue(response.data.dictList,'dictValue','dictKey',this.viewForm.areaId);
          // response.data.dictList.forEach((ele)=>{
          //   if(){
            getDictData('order_require_source').then(res=>{
                this.orderRequireSourcelist = res.data;
                // this.requestDictionaryFlag += 20;
                this.viewForm.sourceName = this.tool.getDictionaryValue(this.orderRequireSourcelist,'dictValue','dictKey',this.viewForm.source);
                console.log(this.viewForm.sourceName);
                this.viewForm = Object.assign({},this.viewForm,{sourceName:this.viewForm.sourceName})
            })
          //   }
          // });
          // this.viewForm.areaName =

          this.dialogOrderViewBoxVisible = true;
        });
      });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success("操作成功!");
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success("操作成功!");
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
    // console.log("form.projectId===>",this.form.projectId);
    //   this.form.projectId = this.projectList[0].id;
      setTimeout(()=>{
        this.form = Object.assign({}, this.form, {
          areaName: '',
          areaId: '',
        });
      })
        // console.log();
        // this.form = Object.assign({}, this.form, {
        //   areaName: '',
        //   areaId: '',
        // });
    //   this.query = { projectId: this.projectList[0].id };
    // console.log("form.projectId===>",this.form.projectId);
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.query = this.form;

      this.query = Object.assign({}, this.form, params);
      console.log(params);
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize,  id:this.$route.query.id?this.$route.query.id:''},
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchChange(params, done) {
      this.query = params;
      this.query = this.form;

      this.query = Object.assign({}, this.form, params);
      console.log(params);
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize},
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    onLoad_(page) {
      page = page || this.page;
      this.loading = true;
      console.log(this.$route.query);
      getList(
          this.$route.query
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style scoped>
</style>
